import React from 'react';
import Heading from './components/Heading/Heading';
import ApkControlPanel from './components/ApkControlPanel/ApkControlPanel';
import ApkList from './components/ApkList/ApkList';
import PaginationComponent from './components/PaginationComponent/PaginationComponent';
import style from './ApkSection.module.scss';

const ApkSection: React.FC = () => {
	return (
		<div className={style.container} data-test="ApkSection">
			<div className={style.wrapper}>
				<Heading />
				<ApkControlPanel />
				<ApkList />
				<PaginationComponent />
			</div>
		</div>
	);
};

export default ApkSection;
